<h1>Confirm Contact Removal</h1>
<div *ngIf="data">
    <div class="row">
        <div class="col-xs-12 col-md-12">
            <p>
                Are you sure you want to delete {{ data.email }}?
            </p>
        </div>
    </div>
</div>
<div>
    <button (click)="saveEdit()" class="mr-1" color="warn" mat-flat-button>
        <mat-icon>delete_forever</mat-icon>
        Delete
    </button>
    <button (click)="onCancelClick()" mat-stroked-button>Cancel</button>&nbsp;
</div>
